
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Job Seekers',
      links: [
        { label: 'Browse Jobs', href: '/jobs' },
        { label: 'Career Advice', href: '#' },
        { label: 'Resume Tips', href: '#' },
        { label: 'Interview Prep', href: '#' },
      ],
    },
    {
      title: 'Employers',
      links: [
        { label: 'Post a Job', href: '/employer' },
        { label: 'Pricing', href: '#' },
        { label: 'Employer Resources', href: '#' },
        { label: 'Hire Talent', href: '#' },
      ],
    },
    {
      title: 'About',
      links: [
        { label: 'About Us', href: '#' },
        { label: 'Our Mission', href: '#' },
        { label: 'Press', href: '#' },
        { label: 'Careers', href: '#' },
      ],
    },
    {
      title: 'Support',
      links: [
        { label: 'Help Center', href: '#' },
        { label: 'Contact Us', href: '#' },
        { label: 'Privacy Policy', href: '#' },
        { label: 'Terms of Service', href: '#' },
      ],
    },
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', label: 'Facebook' },
    { icon: 'ri-twitter-x-fill', href: '#', label: 'Twitter' },
    { icon: 'ri-linkedin-fill', href: '#', label: 'LinkedIn' },
    { icon: 'ri-instagram-fill', href: '#', label: 'Instagram' },
  ];

  return (
    <footer className="bg-[#1c1c1c] border-t border-[#333333] mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="text-white font-semibold text-sm mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('#') ? (
                      <a
                        href={link.href}
                        className="text-[#a0a0a0] text-sm hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-[#a0a0a0] text-sm hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Social Links */}
        <div className="flex justify-center space-x-6 mb-8 pb-8 border-b border-[#333333]">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.href}
              aria-label={social.label}
              className="w-10 h-10 flex items-center justify-center bg-[#2d2d2d] rounded-full text-[#a0a0a0] hover:bg-[#6366f1] hover:text-white transition-all cursor-pointer"
            >
              <i className={`${social.icon} text-lg`}></i>
            </a>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-[#a0a0a0] text-sm">
            © {currentYear} ZingJobs. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#a0a0a0] text-sm hover:text-[#6366f1] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
